module.exports = __webpack_public_path__ + "img/top.d303cc84.svg";